export default Object.freeze({
  INCLUSIVE: "inclusive",
  EXCLUSIVE: "exclusive",
});
